import type { ConsultationFields } from './types';

export const DEFAULT_CONSULTATION_FIELDS: ConsultationFields = {
  isMarkedAsComplimentary: false,
  paymentRequestType: null,
};
